import { PageHeader } from "@/components/PageHeader";
import KbImageRescueCard from "@/pages/settings/KbImageRescueCard";
import KbMediaNamesCard from "@/pages/settings/KbMediaNamesCard";
import KbUnusedMediaCard from "@/pages/settings/KbUnusedMediaCard";

const Column = ({ children, testid }) => (
  <div className="flex min-w-0 flex-col gap-4 [&>*]:!mt-0" data-testid={testid}>{children}</div>
);

/** Settings → Knowledge Base → Images: hosting, file names and unused pictures. */
export default function KbImagesPanel() {
  return (
    <div data-testid="kb-images-panel">
      <PageHeader compact title="Images"
        subtitle="Keep every picture on our own storage, sensibly named, and retire the ones nothing uses any more" />
      <div className="grid grid-cols-1 items-start gap-4 xl:grid-cols-2">
        <Column testid="kb-images-col-1">
          <KbImageRescueCard />
        </Column>
        <Column testid="kb-images-col-2">
          <KbMediaNamesCard />
          <KbUnusedMediaCard />
        </Column>
      </div>
    </div>
  );
}
